import React, { useContext, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { PaymentMethodDataForm, defaultPaymentMethodDataForm } from '../../../app/models/PaymentMethod';
import usePaymentMethodService from '../../../app/services/hooks/usePaymentMethodService';
import PaymentMethodForm from './forms/PaymentMethodForm';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const PaymentMethodCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [paymentMethod, setPaymentMethod] = useState<PaymentMethodDataForm>(defaultPaymentMethodDataForm);
    const [errorFields, setErrorFields] = useState<any>();
    const { fetchingStorePaymentMethod, storePaymentMethod } = usePaymentMethodService();

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando forma de pago...');
        storePaymentMethod(paymentMethod, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <PaymentMethodForm
                        paymentMethodDataForm={paymentMethod}
                        setPaymentMethodDataForm={setPaymentMethod}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStorePaymentMethod} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStorePaymentMethod} />
                </div>
            </div>
        </>
    );
};

export default PaymentMethodCreate;
